/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConsentType } from "./ConsentType";
import type { GenderIdentity } from "./GenderIdentity";
import type { HomeAddressModel } from "./HomeAddressModel";
import type { IdVerificationModel } from "./IdVerificationModel";
import type { InsuranceInfoModel } from "./InsuranceInfoModel";
import type { LinkedAccountModel } from "./LinkedAccountModel";
import type { NotificationPreferencesModel } from "./NotificationPreferencesModel";
import type { PartnerIntentModel } from "./PartnerIntentModel";
import type { PreferredPharmacyModel } from "./PreferredPharmacyModel";
import type { Pronoun } from "./Pronoun";
import type { SexAtBirth } from "./SexAtBirth";

/**
 * Response schema for user profile GET endpoint
 */
export interface UserProfileResponse {
  kind?: "profile";
  user_id: string;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  preferred_name?: string | null;
  /** Date of birth in YYYY-MM-DD format */
  date_of_birth?: string | null;
  sex_at_birth?: SexAtBirth | null;
  gender_identity?: GenderIdentity | null;
  pronouns?: Pronoun | null;
  /** US state or territory abbreviation */
  state_of_residence?: string | null;
  home_address?: HomeAddressModel | null;
  /** IANA timezone identifier */
  timezone?: string | null;
  linked_accounts?: LinkedAccountModel | null;
  consents: Partial<Record<ConsentType, boolean | null>>;
  /** Notification preferences for clinic and nori notifications */
  notification_preferences: NotificationPreferencesModel;
  preferred_pharmacy?: PreferredPharmacyModel | null;
  id_verification?: IdVerificationModel | null;
  /** Partner that referred the user */
  partner_intent?: PartnerIntentModel | null;
  insurance?: InsuranceInfoModel;
  /** Whether the user is in the generalist refactor experience */
  generalist_refactor?: boolean | null;
  /** Fields the client must present as read-only */
  locked_fields?: string[];
}
